export default "__VITE_ASSET__64000052__"